import React from 'react';
import { withSSR } from 'react-i18next';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { CEILINGS_LANDING_NAME } from 'landings/ceilings';
import { State } from 'store/types';
import { unSanitizeLocalization } from 'utils/unsanitize-localiozation';
import '../../../../i18n.config';
import { CeilingsRemote } from '../../common/widgets';
import { initWidgetDataWithShops } from '../init-widget-data-with-shops';

const WithI18 = withSSR()(CeilingsRemote);

registerWidget<State, Record<string, string>>(`${__NAME__}/${CEILINGS_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetDataWithShops(state);
  const {
    localization: { initialI18nStore, initialLanguage },
  } = state;
  const updatedInitialI18nStore = unSanitizeLocalization(initialI18nStore);

  return remoteProps => (
    <WithI18
      initialI18nStore={updatedInitialI18nStore}
      initialLanguage={initialLanguage}
      router={router}
      store={store}
      {...remoteProps}
    />
  );
});
